'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _api = require('../middleware/api');

var _api2 = _interopRequireDefault(_api);

var _reduxLogger = require('redux-logger');

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = (0, _reduxLogger2.default)({
  level: 'info',
  collapsed: false,
  logger: console,
  predicate: function predicate() {
    return __DEVELOPMENT__;
  }
}); /* global __DEVELOPMENT__ */


var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, _api2.default, logger)(_redux.createStore);

function configureStore(initialState) {
  var middlewares = [_reduxThunk2.default, _api2.default];
  middlewares.push((0, _reduxLogger2.default)({
    predicate: function predicate() {
      return __DEVELOPMENT__;
    }
  }));

  var store = createStoreWithMiddleware(_reducers2.default, initialState);
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      var nextRootReducer = require('../reducers');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/store/configureStore.js
 ** module id = 840
 ** module chunks = 0
 **/